import React, { Component } from 'react';
import Button from '../../forms/Button';
import PerformancesForm from './PerformancesForm';
import Loading from '../../helpers/Loading';
import { get, find } from 'lodash';
import { initPerformanceClearing } from '../../../selectors/admin/models/lineup';
import PerformancesStates from './PerformancesStates';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmationModal from '../forms/ConfirmationModal';
import { contracts } from '../../../services/api.admin';
import { LOADING_TEXT } from '../../../constants/settings';
import { Prompt } from 'react-router';
import { ARE_YOU_SURE_TEXT } from '../../../constants/texts/errors';
import PerformancesArtistForm from '../../../containers/admin/events/PerformancesArtistForm';
import PerformancesContractForm from '../../../containers/admin/events/PerformancesContractForm';
import { ALL_ID } from '../../../constants/admin/settings';

class PerformancesDetails extends Component {
    state = {
        modalOpen: false,
        edited: false,
        fetchedContracts: false,
        fetchingContracts: false,
        contractToLoad: false,
        artistFormOpen: false,
        contractModalOpen: false,
    };
    componentDidMount() {
        this._fetchDependencies();
        this._initStates();
    }
    componentDidUpdate(prevProps, prevState) {
        this._fetchDependencies();
        this._initStates();
        if (prevState.edited === false && this.state.edited) {
            this.props.blockTabSwitch();
        } else if (prevState.edited === true && !this.state.edited) {
            this.props.enableTabSwitch();
        }
        if (this.props.data.artistId !== prevProps.data.artistId) {
            this.setState({ edited: true });
        }
    }
    _initStates() {
        const { partners } = this.props.dependencies;
        if (!this.props.loading && partners && partners.length !== (this.props.data.clearing || []).length) {
            const clearing = initPerformanceClearing(this.props.data, partners);
            this.props.onInput(clearing, 'clearing');
        }
    }
    _fetchDependencies = async () => {
        if (this.props.shouldFetchDependencies) {
            this.props.fetchDependencies();
        }
        if (this.props.data.artistId && !this.state.fetchingContracts && !this.state.fetchedContracts) {
            this.setState({ fetchingContracts: true });
            const resp = await contracts.getForEventAndArtist(
                this.props.eventId,
                this.props.data.artistId,
                this.props.organizationId
            );
            const allContracts = get(resp, 'json.contracts') || [];
            const contractToLoad =
                find(allContracts, (x) => x.signedOn && find(x.performances, (y) => y.id === this.props.data.id)) ||
                find(allContracts, (x) => x.signedOn && find(x.performances, (y) => y.id === ALL_ID)) ||
                false;
            this.setState({ contractToLoad, fetchedContracts: true, fetchingContracts: false });
        }
    };
    _delete = () => this.props.delete(this.props.data.id, () => this._closeConfirm);
    _openConfirm = () => this.setState({ modalOpen: true });
    _closeConfirm = () => this.setState({ modalOpen: false });
    _onInput = (value, name) => {
        this.setState({ edited: true });
        if (name === 'artistId') {
            const artist = find(this.props.artists, (x) => x.value === value);
            this.setState({ fetchedContracts: false });
            this.setState({ artistFormOpen: { name: artist.label, id: artist.value } });
        }
        this.props.onInput(value, name);
    };
    _loadContractInfo = () => {
        const clearing = [...this.props.data.clearing];
        const contractClearing = this.state.contractToLoad.clearing || [];
        this.props.onInput(
            clearing.map((c) => find(contractClearing, (cc) => cc.partnerId === c.partnerId) || c),
            'clearing'
        );
        this.setState({ edited: true });
    };
    _onSetClearing = (f, v) => {
        this.setState({ edited: true });
        this.props.setClearing(f, v);
    };
    _cancel = () => {
        this.setState({ edited: false });
        this.props.cancel();
    };
    _submit = () => {
        this.setState({ edited: false });
        this.props.submit();
    };
    _openArtistForm = () => this.setState({ artistFormOpen: true });
    _closeArtistForm = () => this.setState({ artistFormOpen: false });
    _openContractModal = () => this.setState({ contractModalOpen: true });
    _closeContractModal = () => this.setState({ contractModalOpen: false });
    _artistName = () => (find(this.props.artists, (a) => a.value === this.props.data.artistId) || {}).label || '';

    render() {
        return (
            <div className="ckp-admin-performances-form">
                <PerformancesArtistForm
                    eventId={this.props.eventId}
                    onClose={this._closeArtistForm}
                    open={this.state.artistFormOpen}
                    organizationId={this.props.organizationId}
                    contextId={this.props.contextId}
                />
                <PerformancesContractForm
                    fetchSigningUsers={this.props.fetchSigningUsers}
                    eventName={this.props.eventName}
                    artistName={this._artistName()}
                    performanceId={this.props.data.id}
                    artistId={this.props.data.artistId}
                    eventId={this.props.eventId}
                    onClose={this._closeContractModal}
                    open={this.state.contractModalOpen}
                    organizationId={this.props.organizationId}
                    stages={this.props.stages}
                />
                <Prompt when={this.state.edited} message={ARE_YOU_SURE_TEXT} />
                <ConfirmationModal
                    open={this.state.modalOpen}
                    className="is-black"
                    onClose={this._closeConfirm}
                    onConfirm={this._delete}
                    title="Remove Performance"
                    confirmText="Are you sure you want to delete this performance?"
                    confirmLabel="Delete"
                />
                <header className="ckp-admin-performances-form-title">
                    <h4 className="ckp-ts-h1">Performance Details</h4>
                    <div className="ckp-admin-performances-form-buttons">
                        {this.props.data.id ? (
                            <a className="ckp-buttons-text is-with-icon is-auto-width" onClick={this._openConfirm}>
                                <DeleteIcon />
                                Delete
                            </a>
                        ) : null}
                        <a className="ckp-buttons-text is-auto-width" onClick={this._cancel}>
                            Cancel
                        </a>
                        <Button
                            inactive={!this.props.canSubmit || !this.state.edited}
                            className="ckp-admin-performances-form-button is-auto-width"
                            label="Save"
                            onClick={this._submit}
                        />
                    </div>
                </header>
                {this.props.loading ? (
                    <Loading className="is-big" label={LOADING_TEXT} size={40} color="white" />
                ) : (
                    <main>
                        <PerformancesForm
                            data={this.props.data}
                            artists={this.props.artists}
                            stages={this.props.stages}
                            onInput={this._onInput}
                            openArtist={this._openArtistForm}
                        />
                        <PerformancesStates
                            openContractModal={this._openContractModal}
                            performanceId={this.props.data.id}
                            loadContractInfo={this._loadContractInfo}
                            fetchingContracts={this.state.fetchingContracts}
                            contractToLoad={this.state.contractToLoad}
                            setClearing={this._onSetClearing}
                            dependencies={this.props.dependencies}
                            clearing={this.props.data.clearing}
                        />
                    </main>
                )}
            </div>
        );
    }
}

export default PerformancesDetails;



// WEBPACK FOOTER //
// ./src/components/admin/lineup/PerformancesDetails.js